import React from "react";

export const ChartBar = ({color="black", width="24", height="24"}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
    >
      <path
        d="M38.0625 34.125C38.0625 34.4731 37.9242 34.8069 37.6781 35.0531C37.4319 35.2992 37.0981 35.4375 36.75 35.4375H5.25C4.9019 35.4375 4.56806 35.2992 4.32192 35.0531C4.07578 34.8069 3.9375 34.4731 3.9375 34.125C3.9375 33.7769 4.07578 33.4431 4.32192 33.1969C4.56806 32.9508 4.9019 32.8125 5.25 32.8125H6.5625V22.3125C6.5625 21.9644 6.70078 21.6306 6.94692 21.3844C7.19306 21.1383 7.5269 21 7.875 21H11.8125C12.1606 21 12.4944 21.1383 12.7406 21.3844C12.9867 21.6306 13.125 21.9644 13.125 22.3125V32.8125H15.75V14.4375C15.75 14.0894 15.8883 13.7556 16.1344 13.5094C16.3806 13.2633 16.7144 13.125 17.0625 13.125H22.3125C22.6606 13.125 22.9944 13.2633 23.2406 13.5094C23.4867 13.7556 23.625 14.0894 23.625 14.4375V32.8125H26.25V6.5625C26.25 6.2144 26.3883 5.88056 26.6344 5.63442C26.8806 5.38828 27.2144 5.25 27.5625 5.25H34.125C34.4731 5.25 34.8069 5.38828 35.0531 5.63442C35.2992 5.88056 35.4375 6.2144 35.4375 6.5625V32.8125H36.75C37.0981 32.8125 37.4319 32.9508 37.6781 33.1969C37.9242 33.4431 38.0625 33.7769 38.0625 34.125Z"
        fill={color}
      />
    </svg>
  );
};
